/**
 * Footer component
 */

// React
import React from 'react';

import { styled } from '@mui/material/styles';
import logoBlack from 'assets/images/artfreak-logo-black.svg';

const FooterContainer = styled('footer')({
  padding: '30px',
  userSelect: 'none',
});

const StyledImage = styled('img')({
  width: '100%',
  height: '25px',
});

// Component
const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <StyledImage src={logoBlack} alt="Omotas logo" />
    </FooterContainer>
  );
};

export default Footer;
